<template>
  <b-card>
    <display-user :user="user" />
    <hr class="mb-2">

    <b-row>
      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <h6 class="text-muted font-weight-bolder">
          {{ $t('Bank account owner') }}
        </h6>
        <h5 class="mb-0">
          {{ user.bank_account_owner }}
        </h5>
      </b-col>
      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <h6 class="text-muted font-weight-bolder">
          {{ $t('Bank account number') }}
        </h6>
        <h5 class="mb-0">
          {{ user.bank_account_number }}
        </h5>
      </b-col>
      <b-col
        cols="12"
        md="6"
        class="mb-1"
      >
        <h6 class="text-muted font-weight-bolder">
          {{ $t('Bank account card number') }}
        </h6>
        <h5 class="mb-0">
          {{ user.bank_account_card_number }}
        </h5>
      </b-col>
      <b-col
        cols="12"
      >
        <h6 class="text-muted font-weight-bolder">
          {{ $t('Bank account sheba number') }}
        </h6>
        <h5 class="mb-0">
          {{ user.bank_account_sheba_number }}
        </h5>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import DisplayUser from '../../core/DisplayUser'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    DisplayUser,
  },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
